var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{staticClass:"recaptcha-badge"},[_c('div',{ref:"host"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }